/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Pulkit's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Pulkit Giddu Portfolio",
    type: "website",
    url: "http://PulkitGiddu.com/",
  },
};

//Home Page
const greeting = {
  title: "Pulkit Giddu",
  logo_name: "Pulkit Giddu",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/14wsSr_Vuiq59uT4xOCJLDIhuxDEcSyX0/view?usp=sharing",
  githubProfile: "https://github.com/PulkitGiddu",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/PulkitGiddu",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/pulkit-giddu-223780206/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:pulkitgiddu09@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Android Development",
      fileName: "DataScieneImg",
      skills: [
        "⚡ Developing highly scalable models for various domains",
        "⚡ Experience of working with Backend and Frontend development",
      ],
      softwareSkills: [
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            backgroundColor: "transparent",
            color: "#3DDC84",
          },
        },
        {
          skillName: "FireBase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            backgroundColor: "trasparent",
            color: "#F5820D",
          },
        },
        {
          skillName: "Realm",
          fontAwesomeClassname: "simple-icons:realm",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "JAVA",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Java",
        "⚡ Creating application backend in Node.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Setting up streaming jobs from DB to Server ",
      ],
      softwareSkills: [
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/PulkitGiddu/",
    },

    {
      siteName: "GitHub",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://github.com/PulkitGiddu",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/pulkitgiddu09",
    },

    {
      siteName: "CodeStudio",
      iconifyClassname: "simple-icons:codingninjas",
      style: {
        color: "#2EC866",
      },
      profileLink:
        "https://www.codingninjas.com/codestudio/profile/d91eb079-4a0c-4444-b1ed-e31c8d98e751",
    },

    {
      siteName: "GfG",
      iconifyClassname: "simple-icons:geeksforgeeks",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://auth.geeksforgeeks.org/user/pulkitgiddu09/practice",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Vishwakarma Institute of Technology",
      subtitle: "B.Tech. in Electronics & Telecommunication Engineering",
      logo_path: "vitlogo.png",
      alt_name: "VIT Pune",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ Final Year Student.",
        "I am studing Computer and IT subjects such as Data Structures, DataBase Management System, Operating System, Computer Architecture, Object Oriented Programing etc.",
        "Apart from this, I have done courses on Android Development, Data Science, Cloud Computing and Full Stack Development.",
      ],
      website_link: "https://www.vit.edu/",
    },
    {
      title: "KENDRIYA VIDYALAYA NO.I GANDHI NAGAR (JAMMU)",
      subtitle: "HSE Science",
      logo_path: "kv.png",
      alt_name: "K V No 1 Jammu",
      duration: "2019 - 2020",
      descriptions: [
        "I have varity of courses like Maths, Physics, Chemistry, Biology.",
        "Apart from this, I have very good with my extracurricular's.",
      ],
      website_link: "https://no1jammu.kvs.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Problem Solving Basic",
      subtitle: "- Hacker Rank",
      logo_path: "hacker.png",
      certificate_link:
        "https://drive.google.com/file/d/1vdvPJS3ihfUi0BJQvZNGMK_Iv6AqilSs/view?usp=sharing",
      alt_name: "Hacker Rank",
      color_code: "#FFFFFF",
    },
    {
      title: "Paper Publication",
      subtitle: "- YMER",
      logo_path: "ymer.png",
      certificate_link:
        "https://drive.google.com/file/d/1Bb5CZV8WMS04pIlAuZ43aIyXuwpo-muI/view?usp=sharing",
      alt_name: "YMER",
      color_code: "#FFFFFF",
    },
    {
      title: "CPP Workshop",
      subtitle: "- Technocarts",
      logo_path: "techno.png",
      certificate_link:
        "https://drive.google.com/file/d/1P5uuN0bcaWQaX66TYmxRERWX5-VStWFw/view?usp=sharing",
      alt_name: "Technocarts",
      color_code: "#FFFFFF",
    },
    {
      title: "Stock Analysis",
      subtitle: "- Krishna Foundation",
      logo_path: "bse.png",
      certificate_link:
        "https://drive.google.com/file/d/17aGpKkioyblUXXiFKbehBdNAOllgkTf3/view?usp=sharing",
      alt_name: "BSE",
      color_code: "#FFFFFF",
    },
    {
      title: "SQL",
      subtitle: "- LinkedIn",
      logo_path: "linkedin.png",
      certificate_link:
        "https://drive.google.com/file/d/1KlU5ciX_FhyNoeTzNfs-sMrHHotFW_-N/view?usp=sharing",
      alt_name: "SQL",
      color_code: "#FFFFFF",
    },
    {
      title: "INPACT 2.0 Startup",
      subtitle: "- Savitribai Phule Pune University",
      logo_path: "pvt.png",
      certificate_link:
        "https://drive.google.com/file/d/1WTV2y1yflJNlBMin89G8ltcGsuOqRrbg/view?usp=sharing",
      alt_name: "2.0",
      color_code: "#FFFFFF",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with Erfiden Pvt Ltd. as Android Developer, Designer and Software Architect. I love organising events and participate in open source communities.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Android Development Freelance",
          company: "Erfiden Pvt Ltd.",
          logo_path: "pvt.png",
          duration: "Sep 2022 - Jan 2023",
          location: "Pune, Maharashtra",
          description:
            "Work is to transform a Non-Veg mart website into an Android application with integrated server and client-side capabilities, empowered with seamless payments and efficient delivery services.",
          color: "#0879bf",
        },
      ],
    },

    {
      title: "Extra-Curricular",
      experiences: [
        {
          title: "Sarthi Activity",
          company: "Social Welfare and Development Committee",
          company_url: "https://swd.vit.edu/GP2/index.php",
          logo_path: "sarthi.png",
          location: "Pune, Maharashtra",
          description:
            "I  volunteered  with  the  Social  Welfare  and  Development  Committee Initiative, where I managed 1500+ member and contributed to the betterment of local communities by spreading awareness and promoting access to government programs aimed at supporting small businesses and entrepreneurs.",
          color: "#4285F4",
        },
        {
          title: "Technical Coordinator",
          company: "Student  Training  &  Development Committee",
          logo_path: "tech.png",
          location: "Pune, Maharashtra",
          description:
            "As  a  Technical  Coordinator in  Student  Training  &  Development Committee at VIT Pune, I oversaw the technical training and development of students in various programs and activities.",
          color: "#4285F4",
        },
        {
          title: "Impact Conclave 2.0",
          logo_path: "sppu.png",
          location: "Pune, Maharashtra",
          description:
            "Project selected under Smart Innovation in IMPACT CONCLAVE 2.0 (Startup) organized by Savitribai Phule Pune University & Krishna Institute of Medical Sciences.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is on Android and Web development.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Smart Cradle System",
      createdAt: "2022-12-06T16:26:54Z",
      description: "Paper Domain is IoT Published in YMER ",
      url: "https://ymerdigital.com/uploads/YMER2111Q3.pdf",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name:
        "Stairs Count and Zebra Crossing Distance Estimation for Visually Impaired Individuals",
      createdAt: "",
      description: "Soon will be published in IEEE ",
      url: "",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "A Simplified Approach for  Food Ordering and Tracking System",
      createdAt: "",
      description: "Soon will be published in IEEE ",
      url: "",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "image.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, React, Android and Cloud Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Lower Indra Nagar Bibwewadi, Pune, Maharashtra- 411037",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/orSv7uo1STGSCTkd9",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
